
import { useState } from "react";
import { RentalFormData } from "./useRentalFormState";
import type { RentalStatus } from "@/types/entities/rental";

export function useRentalValidation() {
  const [validationErrors, setValidationErrors] = useState<string[]>([]);

  const validateForm = (formData: RentalFormData, selectedKits: string[]): string[] => {
    const errors: string[] = [];

    console.log('[useRentalValidation] Validating form data:', formData);

    // Note: dynamic status IDs are used from domain statuses; do not restrict to enum values

    if (!formData.clientId) {
      errors.push("Выберите клиента");
    }

    if (!formData.rentalPointId) {
      errors.push("Выберите пункт проката");
    }

    if (!formData.startDate) {
      errors.push("Выберите дату начала аренды");
    }

    if (!formData.endDate) {
      errors.push("Выберите дату окончания аренды");
    }

    if (formData.startDate && formData.endDate && formData.startDate >= formData.endDate) {
      errors.push("Дата окончания должна быть позже даты начала");
    }

    // Validate status presence (IDs come from settings; no enum restriction here)
    console.log('[useRentalValidation] Checking status presence:', {
      status: formData.status,
      statusType: typeof formData.status
    });
    
    if (!formData.status) {
      errors.push("Выберите статус аренды");
    }

    if (formData.inventoryItems.length === 0 && selectedKits.length === 0) {
      errors.push("Выберите хотя бы один элемент инвентаря или комплект");
    }

    if (formData.discount < 0 || formData.discount > 100) {
      errors.push("Скидка должна быть от 0 до 100%");
    }

    if (formData.depositAmount < 0) {
      errors.push("Сумма залога не может быть отрицательной");
    }

    console.log('[useRentalValidation] Validation errors:', errors);

    setValidationErrors(errors);
    return errors;
  };

  const clearValidationErrors = () => {
    setValidationErrors([]);
  };

  return {
    validationErrors,
    validateForm,
    clearValidationErrors
  };
}
